import { render, staticRenderFns } from "./dsfDialogIframe.vue?vue&type=template&id=7ddbfa0c&"
import script from "./dsfDialogIframe.vue?vue&type=script&lang=js&"
export * from "./dsfDialogIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/dialog/dsfDialogIframe.vue"
export default component.exports